import { useAppContext } from '@/contexts/AppContext/AppContext';
import type React from 'react';
import type { ReactNode } from 'react';
import styles from './FeatureFlag.module.css';

interface Props {
    feature?: string;
    children: ReactNode;
    fallback?: ReactNode;
}

const CAN_SEE_FF_HIGHLIGHT_FEATURE = 'FTR_CAN_SEE_FF_HIGHLIGHT';

export const FeatureFlagWrapper: React.FC<Props> = ({
    feature = CAN_SEE_FF_HIGHLIGHT_FEATURE,
    children,
    fallback = null,
}) => {
    const { hasFeature } = useAppContext();
    const enabledForFeature = hasFeature(feature);

    if (!enabledForFeature) {
        return fallback;
    }

    if (hasFeature(CAN_SEE_FF_HIGHLIGHT_FEATURE)) {
        return <div className={styles.wrapper}>{children}</div>;
    }

    return children;
};
